import requester from "api/requester"
import { DEFAULT_SUGGESTED_MEALS_PAGE_SIZE } from "config"
import { MealType } from "model/food/types"
import {
  ICreateMealPayload,
  IUpdateMealPayload,
} from "model/food/types/mealPayload.types"

interface IFavoriteMealAPI {
  getFavoriteMeals: ({
    page,
    signal,
  }: {
    page: number
    signal: AbortSignal
  }) => Promise<{ favoriteMeals: MealType[]; totalPages: number }>
  getFavoriteMealDetails: (id: string) => Promise<MealType>
  createFavoriteMeal: (payload: ICreateMealPayload) => Promise<MealType>
  updateFavoriteMeal: (payload: IUpdateMealPayload) => Promise<MealType>
  deleteFavoriteMeal: (id: string) => Promise<void>
}

const favoriteMealsAPI: IFavoriteMealAPI = {
  getFavoriteMeals({ page, signal }) {
    return requester.get(
      "/favorite-meals",
      {
        page,
        perPage: DEFAULT_SUGGESTED_MEALS_PAGE_SIZE,
      },
      { signal },
    )
  },

  getFavoriteMealDetails(id) {
    return requester.get(`/favorite-meals/${id}`)
  },

  createFavoriteMeal(payload) {
    return requester.post("/favorite-meals", payload)
  },

  updateFavoriteMeal({ payload, id }) {
    return requester.put(`/favorite-meals/${id}`, payload)
  },

  deleteFavoriteMeal(id) {
    return requester.delete(`/favorite-meals/${id}`)
  },
}

export default favoriteMealsAPI
